<template>
    <transition>
        <div class="hot-list">
            <div class="hot-body" style="border-bottom: 1px solid #eee;">
                <div class="flex-row" style="color: #767676;">
                    <span>
                        <i
                            class="iconfont icon-collection"
                            style="vertical-align: middle;color: #484848;"
                        ></i>
                        {{$t('recent_search')}}
                    </span>
                    <span @click="clearRecord" class="hover-class">{{$t('clear_record')}}</span>
                </div>
                <div class="flex-row-wrap">
                    <div
                        class="city-tag"
                        v-for="(item, i) in $store.getters.historyCityList"
                        :key="i"
                        @click="select(item)"
                    >{{item.hotelName || item.areaName || item.cityName || item.city_name || item.name}}</div>
                </div>
            </div>
            <div class="hot-body">
                <div class="flex-row" style="color: #767676;">
                    <span>
                        <i
                            class="iconfont icon-recommend"
                            style="vertical-align: middle;color: #484848;"
                        ></i>
                        {{$t('hot_rec')}}
                    </span>
                </div>
                <div class="flex-row-wrap">
                    <span
                        class="city-text"
                        v-for="(item, i) in $store.getters.hotList"
                        :key="i"
                        @click="select(item)"
                    >{{item.city_name}}</span>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            hotCityList: []
        };
    },
    computed: {
        ...mapGetters(["hotList"])
    },
    created() {
        if (this.hotList && this.hotList.length > 0) {
            return;
        }

        this.$req.post("v2/hotCity").then(resp => {
            if (resp.data.code === "2000") {
                this.hotCityList = resp.data.data;
                this.$store.dispatch("updateHotList", resp.data.data);
            }
        });
    },
    methods: {
        clearRecord() {
            this.$store.dispatch("clearHistoryCityList");
        },
        select(child) {
            let name = child.city_name || child.name;
            this.$emit("menu-select", name, child);
        }
    }
};
</script>

<style lang="scss" scoped>
.hot-list {
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 2048;
    width: 390px;
    font-size: 14px;
    color: #484848;
    background-color: #fff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16),
        0px 2px 5px 0px rgba(0, 0, 0, 0.26);

    .hot-body {
        box-sizing: border-box;
        padding: 10px 16px 0;
    }

    .hover-class {
        cursor: pointer;
        &:hover {
            opacity: 0.7;
        }
    }
}

.flex-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 10px;
}

.flex-row-wrap {
    display: flex;
    // justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 10px;

    .city-text {
        display: inline-block;
        color: #484848;
        margin-right: 20px;
        margin-bottom: 10px;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }

    .city-tag {
        max-width: 100px;
        box-sizing: border-box;
        background-color: #49beb7;
        color: #fff;
        padding: 3px;
        margin-right: 10px;
        margin-bottom: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/HotCItyList.vue